/**
 * File for vue initialise functions for versions
 * 
 * Author: Andrea López
 */

import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getVersionConfig } from '../services/versions.helpers';

/**
 * Function to initialise versions on vue instance
 */
export function versionsVueInitialise (): any {
    const store = useStore();
    const route = useRoute();

    const versionApp = ref<string>(getVersionConfig());
    const versionLoaded = computed(():boolean => {
        return versionApp.value !== '';
    });

    /**
	 * Function to update store
	 */
	function updateStore (action: string, data: any[] = []): void {
		store.dispatch(action, data);
	}

    /**
     * Update the version on the app
     * @param version 
     */
    function updateVersionApp (version: string): void {
        versionApp.value = version;
        updateStore('axn_updateAppVersion', version as any);
    }

    function queryListener (): void {
        if (!route.query) { return; }

		const { version } = route.query;
		if (!version) { return; }

        updateVersionApp(version as any);
    }

    /**
     * Set the version on the body
     */
    function setVersionBody (): void {
        const body = document.querySelector('body');
        body?.setAttribute('data-version', versionApp.value);
    }

    watch(() => route.query, () => {
		queryListener();
        setVersionBody();
	})

    onMounted(() => {
        queryListener();
        setVersionBody();
    });

    return { versionLoaded }
}
